import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ImageCard from '../../components/ImageCard/ImageCard'; // Ваш компонент из предыдущего вопроса
import './Cabinetpage.css'
import Chill_zone1 from '../../images/Cab_photos/chill_zone/1743005343706.jpg'
import Chill_zone2 from '../../images/Cab_photos/chill_zone/1743005343711.jpg'
import Chill_zone3 from '../../images/Cab_photos/chill_zone/1743005343715.jpg'

const CabinetPage2 = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('description');
  
  const cabinetData = {
    id: 1,
    title: 'Зона отдыха "Под лестницей"',
    images: [
      Chill_zone1,
      Chill_zone2,
      Chill_zone3
    ],
    description: <span><b>Зона отдыха — пространство, созданное с душой</b><br/> В нашей школе есть особое место, где царит атмосфера уюта и творчества — это зона отдыха, которую ученики обустраивали своими руками. От идеи до воплощения — всё сделано с любовью и вниманием к деталям.<br/><br/><b>Место для общения и вдохновения</b><br/> Здесь кипит жизнь: на переменах звучит смех, после уроков собираются ребята для общения по интересам.<br/><br/> <b>Гордость школы</b><br/> Эта зона — не просто место для отдыха, а символ сплочённости и креативности наших учеников. Она показывает, что когда мы работаем вместе, можем создавать по-настоящему крутые проекты. И самое главное — здесь всегда рады новым идеям!</span>,

  };

  return (
    <div className="cabinet-page">
      
      <h1 className="cabinet-title">{cabinetData.title}</h1>
      
        <ImageCard 
          images={cabinetData.images} 
          description={'"Школа - это не только уроки и домашние задания, это еще общение и дружба"'}
        />
        <hr className='razdel'/>
      
      <div className="cabinet-content">
        {activeTab === 'description' && (
          <div className="description-section">
            <p>{cabinetData.description}</p>
          </div>
        )}
      </div>
      <div className="next-floor-button-container">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
    </div>
    </div>
  );
};

export default CabinetPage2;